import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=32e16aee&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e16aee')) {
      api.createRecord('32e16aee', component.options)
    } else {
      api.reload('32e16aee', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=32e16aee&", function () {
      api.rerender('32e16aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IdCpOzW0sADv/JS/comp/ImgFallback.vue"
export default component.exports